import List from 'ln/list/List';
import { Signal, EmptyCallback } from 'ln/signal/Signal';
import ExtensionModel from './ExtensionModel';
import CourseElementModel from './CourseElementModel';
import SequenceModel from './UserSequenceModel';
import UserModel from './UserModel';
import PauseModel from './PauseModel';
import DaybreakModel from './DaybreakModel';
import moment from 'moment';
import { backend } from '../../setup';
import setup from 'ln/setup/setup';
import FeedbackSequenceModel from './FeedbackSequenceModel';
import Lang from 'ln/lang/Lang';

class UserCourseModel extends ExtensionModel {
	
	public rerenderDisplayTime:Signal<EmptyCallback>;

	constructor( json:Object ){
		super( json );

		this.rerenderDisplayTime = new Signal<EmptyCallback>();
	}

	get previewMode():boolean{
		return this.get<boolean>( 'previewMode', false );
	}
	
	get title():string {
		return this.get<string>( 'title' );
	}
	
	set title( t:string ){
		this.set( 'title', t );	
	}
	
	get modelName():string {
		return this.get<string>( 'modelName' );
	}

	get id():string {
		return this.get<string>( 'id' );
	}
	
	get image():number {
		return this.get<number>( 'image' );
	}
	
	get level():number {
		return this.get<number>( 'level' );
	}

	get type():string {
		return this.get<string>( 'type' );
	}

	get form():string {
		return this.get<string>( 'form' );
	}

	get location():string {
		return this.get<string>( 'location' );	
	}
	
	set location( l:string ){
		this.set( 'location', l );	
	}
	
	get participants():number{
		return this.get<number>( 'participants' );
	}
	
	set participants( p:number ){
		this.set( 'participants', p );
	}
	get description():string {
		return this.get<string>( 'description' );	
	}
	
	set description( d:string ){
		this.set( 'description', d );	
	}

	get firstDaybreak():DaybreakModel {
		return <DaybreakModel>this.sequences.first();
	}
	
	// get date():string {
	// 	var daybreak = <DaybreakModel> this.sequences.first();
	// 	const splitDate = daybreak.date_as_string.split('-');
	// 	let day = splitDate[2];
	// 	let month = splitDate[1];
	// 	let year = splitDate[0];
	// 	let time = daybreak.time.split( ':' );
	// 	let hours = parseInt(time[0]) < 10 ? `0${time[0]}` : time[0];
	// 	let minutes = time[1] ? ( parseInt(time[1]) < 10 ? `0${time[1]}` : time[1] ) : "00"
	// 	return `${year}-${month}-${day} ${hours}:${minutes}:00`;
	// }

	get version():string{
		return this.get<string>( 'version' );
	}
	
	get sequences():List<CourseElementModel>{
		return this.get<List<CourseElementModel>>( 'sequences' );
	}
	
	set sequences( list:List<CourseElementModel> ){
		this.set( 'sequences', list );
	
		// listen on the events course elements
		list.added.add( this.saveRelations, this );
		list.removed.add( this.saveRelations, this );
	}

	public getPreviousElement( model:CourseElementModel ){
		var index = this.sequences.index( model );
		if( index > 0 && ( model.get( 'modelName') != 'Daybreak' || model.get( 'modelName' ) != 'DaybreakPreview' ) ){
			return <CourseElementModel> this.sequences.get( index - 1 );
		}
		return model;
	}
	
	get duration():number{
		var duration:number = 0;
		this.sequences.all().forEach( ( sequence:SequenceModel ) => {
			if(
				sequence.modelName == 'App\\UserSequence' ||
				sequence.modelName == 'App\\UserSequencePreview' ||
				sequence.modelName == 'App\\SlrgUserSequence' ||
				sequence.modelName == 'App\\SlrgUserSequencePreview' ||
				sequence.modelName == 'App\\CustomUserSequence' ||
				sequence.modelName == 'App\\CustomSlrgUserSequence' ||
				sequence.modelName == 'App\\FeedbackSequence' ) duration += Number( sequence.time );
		});
		return duration;
	}
	
	get pauseDuration():number{
		var pauseDuration:number = 0;
		this.sequences.all().forEach( ( sequence ) => {
			if( sequence instanceof PauseModel ) pauseDuration += Number( sequence.time );
		});
		return pauseDuration;
	}
	
	get days():number{
		var days:number = 0;
		this.sequences.all().forEach( ( sequence ) => {
			if( sequence instanceof DaybreakModel ) days++;
		});
		return days;
	}

	get guestusers():List<UserModel>{
		return this.get<List<UserModel>>( 'guestusers' );
	}
	
	set guestusers( list:List<UserModel> ){
		this.set( 'guestusers', list );
	}

	get owner():UserModel{
		return this.get<UserModel>( 'owner' );
	}

	get customer():string {
		return this.get<string>( 'customer' );
	}

	set customer( c:string ) {
		this.set( 'customer', c );
	}
	

	/**
	 * Return if course is active or archived
	 */
	get status():string{
		var daybreaks:Array<DaybreakModel> = [];
		this.sequences.all().forEach( ( sequence ) => {
			if( sequence instanceof DaybreakModel ) daybreaks.push( sequence );
		});
		var lastDaybreak = daybreaks.pop();
		var endDate = moment( lastDaybreak.date, "YYYY-MM-DD" );
		var tomorrow = moment( new Date() );
		// set tomorrow to midnight
		tomorrow.milliseconds( 0 ).seconds( 0 ).minutes( 0 ).hours( 0 );

		return ( endDate < tomorrow ) ? 'archived': 'actual';
	}

	get certificationType():string{
		return this.get( 'certified' ) ? 'standard' : 'individual';
	}
	
	private saveRelations(){
		this.save();
	}

	private onListChange(){
		this.rerenderDisplayTime.dispatch();
	}
}

export default UserCourseModel;


backend.mapper.toModel.add( 'App\\UserCourse', function( json:any ) {
	var course = new UserCourseModel( json );
	
	course.guestusers = new List<UserModel>( json.guestusers );

	if( json.sequences ) {

		course.sequences = new List<SequenceModel>( json.sequences );

		if( setup.data( 'feedback_sequence')['enabled'] && !course.previewMode ){
			course.sequences.append( new FeedbackSequenceModel( {
				modelName: 'App\\FeedbackSequence',
				time: setup.data('feedback_sequence.duration')
			}));
		}

		// inject course
		course.sequences.all().forEach( ( sequence:SequenceModel ) => {
			sequence.course = course;
		});

	}

	return course;  
});

backend.mapper.toJson.add( 'App\\UserCourse', function( model:UserCourseModel ){
	var clone = model.object();
	clone['sequences'] = backend.mapper.json( model.sequences.all() );
	clone['guestusers'] = backend.mapper.json( model.guestusers.all() );
	delete clone.origin;

	// remove feedback sequence since it should not be persisted
	clone['sequences'] = clone['sequences'].filter( item => item.modelName !== 'App\\FeedbackSequence' );
	
	return clone;
});